import type { ReactElement } from "react";
import { LIEN } from "./cadre";
import { ENTREES_REGLAGES, REGLAGES_RETOUR_DIRECT, REGLAGES_TITRE } from "./reglages-texts";

/**
 * L'index des reglages (`/regie/reglages`) : une carte par page, avec son lien. Twitch (`/regie/reglages/twitch`),
 * Overlays et Import vivent sous `/regie/reglages/*` ; la Diffusion garde son adresse (`/regie/diffusion`). Les lots
 * suivants (alertes, repliques, sons, des) ajoutent leur entree a `ENTREES_REGLAGES`.
 */
export function ReglagesPage(): ReactElement {
  return (
    <div className="police-texte flex flex-col gap-6 text-[22px] md:text-[24px]">
      <a href="/regie" className={`w-fit text-[20px] ${LIEN}`}>
        {REGLAGES_RETOUR_DIRECT}
      </a>
      <h1 className="police-titre m-0 text-[40px] font-normal text-primary">{REGLAGES_TITRE}</h1>
      <ul className="m-0 grid list-none gap-4 p-0 md:grid-cols-2">
        {ENTREES_REGLAGES.map((entree) => (
          <li key={entree.href}>
            <a
              href={entree.href}
              className="flex h-full flex-col gap-1.5 rounded-md border-2 border-[var(--lisere)] bg-card px-6 py-5 no-underline hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
            >
              <span className="police-nom text-[34px] leading-none text-[#FCDD8E]">
                {entree.titre}
              </span>
              <span className="text-muted-foreground">{entree.description}</span>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
